import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-vip",
  "use": "icon-vip-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-vip\"><path d=\"M384 112a208 208 0 1 0 0 416 208 208 0 0 0 0-416z m0 96a112 112 0 1 1 0 224 112 112 0 0 1 0-224z m289.792-92.928l6.464 0.832a208 208 0 0 1 0.832 408 48 48 0 1 1-18.88-94.08 112 112 0 0 0-0.448-219.712 48 48 0 0 1 12.032-95.04zM576 592a144 144 0 0 1 144 144V832a48 48 0 1 1-96 0v-96a48 48 0 0 0-48-48H192a48 48 0 0 0-48 48V832a48 48 0 1 1-96 0v-96A144 144 0 0 1 192 592h384z m256 0a144 144 0 0 1 144 144V832a48 48 0 1 1-96 0v-96a48 48 0 0 0-48-48h-32a48 48 0 1 1 0-96h32z\" p-id=\"1052\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/vip.svg
// module id = WRQj
// module chunks = 69